// extracted by mini-css-extract-plugin
export default {"chat":"style_chat__2vO5Z","message":"style_message__tC5CQ","input":"style_input__UnKOi","prefix":"style_prefix__yDGHo","suffix":"style_suffix__PQ7Ot"};